import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './preOnboarding.es-AR.json';
import esCL from './preOnboarding.es-CL.json';
import esCO from './preOnboarding.es-CO.json';
import esMX from './preOnboarding.es-MX.json';
import ptBR from './preOnboarding.pt-BR.json';

const preOnboardingTranslations: DomainTranslations = {
  name: 'preOnboarding',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.COLOMBIA]: esCO,
    [Locale.CHILE]: esCL,
  },
};

export default preOnboardingTranslations;
